<template>
    <div :style="theme">
        <layout :settingsConfig="settingsConfig ?? []" :fo_config="fo_config" :account_title="'MES RENDEZ-VOUS'">
            <div id="spacer"></div>
            <div class="container">
                <div class="tabs is-centered">
                    <ul id='account-tabs'>
                        <!-- <li id='infos-tab' class="is-active" @click="switchTab('#infos-tab', 'MesInformations')">
                            <a>
                                <span>Mes informations</span>
                            </a>
                        </li> -->
                        <li id="rdvs-tab" @click="switchTab('#rdvs-tab', 'MesRendezVous')">
                            <a>
                                <span>Mes rendez-vous</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <section class="section">
                    <component :is="activeComponent"></component>
                </section>
            </div>
        </layout>
    </div>
</template>

<script>
import layout from '../Layout.vue'
import MesInformations from './MesInformations.vue'
import MesRendezVous from './MesRendezVous.vue'
export default {
    components : {layout, MesInformations, MesRendezVous},
    name : 'Account',
    props: ['fo_config'],
    data () {
        return {
            activeComponent: 'MesRendezVous'
        }
    },
    methods : {
        switchTab (tab_id, component) {
            let ul = document.querySelector('#account-tabs')
            for (let elt of ul.children) {
                elt.classList.remove('is-active')
            }
            let li = document.querySelector(tab_id)
            li.classList.add('is-active')
            this.activeComponent = component

        }
    },
    computed: {
        theme(){
            return this.fo_config['theme'];
        }
    }
}
</script>
